import * as Errors from "../../shared/node/Errors";

import { BookingData, UserDetails } from "../AppDataProvider/AppDataProvider";
import {
  CreateBookingsForBookingToolDocument,
  CreateBookingsForBookingToolMutation,
  CreateBookingsForBookingToolMutationVariables,
} from "../GeneratedGraphQL";
import { defaultOrganisation, testOrganisation2 } from "./organisation";

import { defaultBookingTool } from "./bookingTool";
import { defaultService } from "./service";
import { format } from "date-fns";
import { getBookingQuestionInput } from "../utils";
// For completely inscrutable reasons, this doesn't work if you import from
// utils directly ¯\_(ツ)_/¯
import { getHtmlDateString } from "../utils/getHtmlDateString/getHtmlDateString";
import { GraphQLError } from "graphql";
import { MockedResponse } from "@apollo/client/testing";
import { noPriceRecurrence } from "./bookings";
// For completely inscrutable reasons, this doesn't work if you import from
// utils directly ¯\_(ツ)_/¯
import { today } from "../utils/today";

const timezone = "Europe/London";
export const successReservedSpaceId = "888777666555444333222555";
const errorReservedSpaceId = "888777666555444333222666";
const organisation = defaultOrganisation;
export const successConfirmBookingId = "888777666555444333222444";

const userDetails: UserDetails = {
  email: "eab@appointedd.com",
  firstName: "Eric",
  lastName: "Blair",
  marketingOptIn: false,
  phone: "+441234567890",
};

export const mockConfirmedBookingSuccessData: BookingData = {
  confirmedBookingIds: ["testBookingId"],
  organisation,
  reservedSpaceId: successReservedSpaceId,
  service: defaultService,
  startDate: new Date("2022-11-16T09:00:00.000Z"),
  timezone,
  userDetails: {
    ...userDetails,
    crmFieldData: {
      date_field: format(today, "yyyy-MM-dd"),
      optional_field: null,
      text_field: "this is a text field",
    },
  },
};

export const mockConfirmedBookingErrorData: BookingData = {
  organisation,
  reservedSpaceId: errorReservedSpaceId,
  startDate: new Date("2022-11-16T09:00:00.000Z"),
  timezone,
  userDetails,
};

const successRequestVariables: CreateBookingsForBookingToolMutationVariables = {
  bookings: [
    {
      bookingNotes: "Create bookings for booking tool notes",
      bookingQuestions: getBookingQuestionInput({
        bookingQuestionData: {},
        bookingQuestions: organisation.externalBookingQuestions,
        pickedServiceId: defaultService._id,
      }),
      customer: {
        ...userDetails,
        crmFieldData: [
          { id: "date_field", value: format(today, "yyyy-MM-dd") },
          { id: "optional_field", value: "" },
          { id: "text_field", value: "this is a text field" },
        ],
      },
      organisationId: organisation._id,
      reservedSpaceId: successReservedSpaceId,
      timezone: timezone,
    },
  ],
  bookingToolId: defaultBookingTool._id,
  createdSource: "test-app",
  locale: "en-GB",
};

export const createBookingsForBookingToolRequestSuccess: MockedResponse<CreateBookingsForBookingToolMutation> =
  {
    request: {
      query: CreateBookingsForBookingToolDocument,
      variables: successRequestVariables,
    },
    result: {
      data: {
        createBookingsForBookingTool: {
          __typename: "CreateBookingsResult",
          bookings: [
            {
              _id: successConfirmBookingId,
            },
          ],
        },
      },
    },
  };

const detailsStepVariables: CreateBookingsForBookingToolMutationVariables = {
  bookings: [
    {
      bookingNotes: "Some notes yay",
      bookingQuestions: getBookingQuestionInput({
        bookingQuestionData: {},
        bookingQuestions: testOrganisation2.externalBookingQuestions,
        pickedServiceId: defaultService._id,
      }),
      customer: {
        crmFieldData: [],
        email: "bobson.dugnutt@fightingbaseball.biz",
        firstName: "Bobson",
        lastName: "Dugnutt",
        marketingOptIn: false,
        phone: "+441234567890",
      },
      organisationId: testOrganisation2._id,
      reservedSpaceId: successReservedSpaceId,
      timezone: timezone,
    },
  ],
  bookingToolId: defaultBookingTool._id,
  createdSource: "test-app",
  locale: "en-GB",
};
const detailsStepVariablesMarketingOptedIn: CreateBookingsForBookingToolMutationVariables =
  {
    bookings: [
      {
        bookingNotes: "Some notes yay",
        bookingQuestions: getBookingQuestionInput({
          bookingQuestionData: {},
          bookingQuestions: testOrganisation2.externalBookingQuestions,
          pickedServiceId: defaultService._id,
        }),
        customer: {
          crmFieldData: [],
          email: "bobson.dugnutt@fightingbaseball.biz",
          firstName: "Bobson",
          lastName: "Dugnutt",
          marketingOptIn: true,
          phone: "+441234567890",
        },
        organisationId: testOrganisation2._id,
        reservedSpaceId: successReservedSpaceId,
        timezone: timezone,
      },
    ],
    bookingToolId: defaultBookingTool._id,
    createdSource: "test-app",
    locale: "en-GB",
  };

const detailsStepCrmVariables: CreateBookingsForBookingToolMutationVariables = {
  bookings: [
    {
      bookingQuestions: getBookingQuestionInput({
        bookingQuestionData: {},
        bookingQuestions: organisation.externalBookingQuestions,
        pickedServiceId: defaultService._id,
      }),
      customer: {
        crmFieldData: [
          { id: "required_text_field", value: "required text answer" },
          { id: "required_date_field", value: getHtmlDateString(today) },
        ],
        email: "bobson.dugnutt@fightingbaseball.biz",
        firstName: "Bobson",
        lastName: "Dugnutt",
        marketingOptIn: false,
        phone: "+441234567890",
      },
      organisationId: organisation._id,
      reservedSpaceId: successReservedSpaceId,
      timezone: timezone,
    },
  ],
  bookingToolId: defaultBookingTool._id,
  createdSource: "test-app",
  locale: "en-GB",
};

export const createBookingsForBookingToolRequestDetailsStepCrmData: MockedResponse<CreateBookingsForBookingToolMutation> =
  {
    request: {
      query: CreateBookingsForBookingToolDocument,
      variables: detailsStepCrmVariables,
    },
    result: {
      data: {
        createBookingsForBookingTool: {
          __typename: "CreateBookingsResult",
          bookings: [{ _id: successConfirmBookingId }],
        },
      },
    },
  };

export const createBookingsForBookingToolRequestDetailsStep: MockedResponse<CreateBookingsForBookingToolMutation> =
  {
    request: {
      query: CreateBookingsForBookingToolDocument,
      variables: detailsStepVariables,
    },
    result: {
      data: {
        createBookingsForBookingTool: {
          __typename: "CreateBookingsResult",
          bookings: [{ _id: successConfirmBookingId }],
        },
      },
    },
  };
export const createBookingsForBookingToolRequestDetailsStepMarketingOptIn: MockedResponse<CreateBookingsForBookingToolMutation> =
  {
    request: {
      query: CreateBookingsForBookingToolDocument,
      variables: detailsStepVariablesMarketingOptedIn,
    },
    result: {
      data: {
        createBookingsForBookingTool: {
          __typename: "CreateBookingsResult",
          bookings: [{ _id: successConfirmBookingId }],
        },
      },
    },
  };

const recurringBookingVariables: CreateBookingsForBookingToolMutationVariables =
  {
    bookings: [
      {
        bookingIds: noPriceRecurrence.bookings.map((b) => b._id),
        bookingQuestions: [],
        customer: {
          crmFieldData: [],
          email: "bobson.dugnutt@fightingbaseball.biz",
          firstName: "Bobson",
          lastName: "Dugnutt",
          marketingOptIn: false,
          phone: "+441234567890",
        },
        organisationId: testOrganisation2._id,
        reservedSpaceId: successReservedSpaceId,
        timezone: timezone,
      },
    ],
    bookingToolId: defaultBookingTool._id,
    createdSource: "test-app",
    locale: "en-GB",
  };
export const createRecurringBookingRequestDetailsStep: MockedResponse<CreateBookingsForBookingToolMutation> =
  {
    request: {
      query: CreateBookingsForBookingToolDocument,
      variables: recurringBookingVariables,
    },
    result: {
      data: {
        createBookingsForBookingTool: {
          __typename: "CreateBookingsResult",
          bookings: [{ _id: successConfirmBookingId }],
        },
      },
    },
  };

const errorRequestVariables: CreateBookingsForBookingToolMutationVariables = {
  bookings: [
    {
      bookingQuestions: [],
      customer: { ...userDetails, crmFieldData: [] },
      organisationId: organisation._id,
      reservedSpaceId: errorReservedSpaceId,
      timezone: timezone,
    },
  ],
  bookingToolId: defaultBookingTool._id,
  createdSource: "test-app",
  locale: "en-GB",
};

export const createBookingsForBookingToolRequestError: MockedResponse<CreateBookingsForBookingToolMutation> =
  {
    request: {
      query: CreateBookingsForBookingToolDocument,
      variables: errorRequestVariables,
    },
    result: { errors: [new GraphQLError("Unable to create booking")] },
  };

export const createBookingsForBookingToolRequestNoDataError: MockedResponse<CreateBookingsForBookingToolMutation> =
  {
    request: {
      query: CreateBookingsForBookingToolDocument,
      variables: errorRequestVariables,
    },
    result: { data: null },
  };

export const createBookingsForBookingToolRequestDetailsStepError: MockedResponse<CreateBookingsForBookingToolMutation> =
  {
    request: {
      query: CreateBookingsForBookingToolDocument,
      variables: detailsStepVariables,
    },
    result: { errors: [new GraphQLError("Unable to create booking")] },
  };

export const invalidOrAlteredCreateBookingsForBookingToolRequestDetailsStep: MockedResponse<CreateBookingsForBookingToolMutation> =
  {
    request: {
      query: CreateBookingsForBookingToolDocument,
      variables: detailsStepVariables,
    },
    result: { errors: [new Errors.UserInputError("Something's changed")] },
  };

export const invalidOrAlteredCreateBookingsForBookingToolRequestPaymentStep: MockedResponse<CreateBookingsForBookingToolMutation> =
  {
    request: {
      query: CreateBookingsForBookingToolDocument,
      variables: successRequestVariables,
    },
    result: { errors: [new Errors.UserInputError("Something's changed")] },
  };

export const createBookingsForBookingToolRequestPayLaterError: MockedResponse<CreateBookingsForBookingToolMutation> =
  {
    request: {
      query: CreateBookingsForBookingToolDocument,
      variables: successRequestVariables,
    },
    result: { errors: [new GraphQLError("Unable to create booking")] },
  };

const multiTierRequestVariables: CreateBookingsForBookingToolMutationVariables =
  {
    bookings: [
      {
        bookingQuestions: getBookingQuestionInput({
          bookingQuestionData: {},
          bookingQuestions: testOrganisation2.externalBookingQuestions,
          pickedServiceId: defaultService._id,
        }),
        customer: {
          crmFieldData: [],
          email: "bobson.dugnutt@fightingbaseball.biz",
          firstName: "Bobson",
          lastName: "Dugnutt",
          marketingOptIn: false,
          phone: "+441234567890",
        },
        organisationId: testOrganisation2._id,
        pricePoints: [{ pricePointId: "c", quantity: 2 }],
        reservedSpaceId: successReservedSpaceId,
        tierId: "1",
        timezone: timezone,
      },
    ],
    bookingToolId: defaultBookingTool._id,
    createdSource: "test-app",
    locale: "en-GB",
  };

export const createBookingsForMultiTierRequestSuccess: MockedResponse<CreateBookingsForBookingToolMutation> =
  {
    request: {
      query: CreateBookingsForBookingToolDocument,
      variables: multiTierRequestVariables,
    },
    result: {
      data: {
        createBookingsForBookingTool: {
          __typename: "CreateBookingsResult",
          bookings: [{ _id: successConfirmBookingId }],
        },
      },
    },
  };
